import PnlBreakdownGetter from "../../../../getters/pnlBreakdownGetter/PnlBreakdownGetter";
import {
  PnlBreakdownFilteredWithMultiDataKey,
  PnlBreakdownFiltersEnum,
  PnlBreakdownWithMultiDataKey,
  ProcessGroupAndMachemetryIdsInput,
} from "reports/getters/pnlBreakdownGetter/pnlBreakdownTypes";

export function PnlBreakdownGettersByProcessGroup({
  processGroupsAndMachemetryIds,
  setData,
  filter,
  ge,
  lt,
}: {
  processGroupsAndMachemetryIds?: ProcessGroupAndMachemetryIdsInput[];
  setData:
    | React.Dispatch<React.SetStateAction<PnlBreakdownWithMultiDataKey[]>>
    | React.Dispatch<
        React.SetStateAction<PnlBreakdownFilteredWithMultiDataKey[]>
      >;
  filter?: PnlBreakdownFiltersEnum;
  ge: number;
  lt: number;
}) {
  return (
    <>
      {processGroupsAndMachemetryIds?.map(
        ({ processGroupName, machemetryIds }) => {
          return (
            <PnlBreakdownGetter
              key={processGroupName}
              range={{ ge, lt }}
              machemetryIds={machemetryIds}
              setPnlBreakdownData={setData}
              filter={filter}
              multiData={true}
              multiDataKey={processGroupName}
            />
          );
        }
      )}
    </>
  );
}
